import axios from '@/utils/request'
const urlPrefix = 'map'
// import _ from 'lodash'
/// ///////////////////////////////////////标注图层//////////////////////////////////////////
// 新建图层数据
export function addLayer (data) {
  return axios({
    url: urlPrefix + '/layer',
    method: 'post',
    data: data
  })
}
// 更新图层
export function updateLayer (data) {
  return axios({
    url: urlPrefix + '/layer',
    method: 'put',
    data: data
  })
}
// 删除图层
export function delLayer (data) {
  return axios({
    url: urlPrefix + '/layer',
    method: 'delete',
    data: data
  })
}
// 获取单个图层详细信息
export function getLayer (params) {
  return axios({
    url: urlPrefix + '/layer',
    method: 'get',
    params: params
  })
}
// 获取图层列表信息
export function getLayerList (params) {
  return axios({
    url: urlPrefix + '/layer/list',
    method: 'get',
    params: params
  })
}
// 解除图层数据绑定
export function freeLayer (data) {
  return axios({
    url: urlPrefix + '/layer/free',
    method: 'post',
    data: data
  })
}
// 获取图层关联数据表可用数据
export function getEnablTableData (params) {
  return axios({
    url: urlPrefix + '/layer/enableTableData',
    method: 'get',
    params: params
  })
}
// 修改标注图文弹窗数据
export function richSnippets (data) {
  return axios({
    url: urlPrefix + '/layer/mark/mark/richSnippets',
    method: 'put',
    data: data
  })
}
/// ///////////////////////////////////////图层自定义属性//////////////////////////////////////////
// 添加图层属性
export function addLayerProperty (data) {
  return axios({
    url: urlPrefix + '/layer/property',
    method: 'put',
    data: data
  })
}
// 更新图层属性
export function updateLayerProperty (data) {
  return axios({
    url: urlPrefix + '/layer/property',
    method: 'put',
    data: data
  })
}
// 获取图层属性信息
export function getLayerProperty (params) {
  return axios({
    url: urlPrefix + '/layer/property/list',
    method: 'get',
    params: params
  })
}
/// ///////////////////////////////////////图层样式//////////////////////////////////////////
// 添加点图层样式
export function addPointStyle (data) {
  return axios({
    url: urlPrefix + '/layer/style/point',
    method: 'post',
    data: data
  })
}
// 更新点图层样式
export function updatePointStyle (data) {
  return axios({
    url: urlPrefix + '/layer/style/point',
    method: 'put',
    data: data
  })
}
// 添加线图层样式
export function addLineStyle (data) {
  return axios({
    url: urlPrefix + '/layer/style/line',
    method: 'post',
    data: data
  })
}
// 更新线图层样式
export function updateLineStyle (data) {
  return axios({
    url: urlPrefix + '/layer/style/line',
    method: 'put',
    data: data
  })
}
// 添加面图层样式
export function addPolygonStyle (data) {
  return axios({
    url: urlPrefix + '/layer/style/plane',
    method: 'post',
    data: data
  })
}
// 更新面图层样式
export function updatePolygonStyle (data) {
  return axios({
    url: urlPrefix + '/layer/style/plane',
    method: 'put',
    data: data
  })
}
/// ///////////////////////////////////////标注//////////////////////////////////////////
// 更新图层默认名称字段
export function updateLayerName (data) {
  return axios({
    url: urlPrefix + '/layer/mark/name',
    method: 'put',
    data: data
  })
}
// 添加标注
export function addMarker (data) {
  return axios({
    url: urlPrefix + '/layer/mark',
    method: 'post',
    data: data
  })
}
// 批量添加标注
export function addMarkerBatch (data) {
  return axios({
    url: urlPrefix + '/layer/mark/batch',
    method: 'post',
    data: data
  })
}
// 批量添加普通标注
export function addDeviceMarkerBatch (data) {
  return axios({
    url: urlPrefix + '/layer/mark/batchSave',
    method: 'post',
    data: data
  })
}
// 更新标注
export function updateMarker (data) {
  return axios({
    url: urlPrefix + '/layer/mark',
    method: 'put',
    data: data
  })
}
// 删除标注
export function delMarker (data) {
  return axios({
    url: urlPrefix + '/layer/mark',
    method: 'delete',
    data: data
  })
}
// 获取单个标注详情
export function getMarkerDetails (params) {
  return axios({
    url: urlPrefix + '/layer/mark',
    method: 'get',
    params: params
  })
}
// 获取标注分页gis信息
export function getMarkersGis (params) {
  return axios({
    url: urlPrefix + '/layer/mark/list/gis',
    method: 'get',
    params: params
  })
}
// 获取所有标注gis信息
export function getAllMarkersGis (params) {
  return axios({
    url: urlPrefix + '/layer/list/mark/gis/all',
    method: 'get',
    params: params
  })
}
// 获取单个标注列表
export function getMarkerList (params) {
  return axios({
    url: urlPrefix + '/layer/mark/page',
    method: 'get',
    params: params
  })
}

// 获取地图绑定的模型
export function getMapModel (params) {
  return axios({
    url: urlPrefix + '/area/model',
    method: 'get',
    params: params
  })
}

// 标注列表导出
export function exportData (params) {
  return axios({
    url: urlPrefix + '/layer/mark/export/excel',
    method: 'get',
    params: params
  })
}
// 搜索标注
export function searchMarkers (params) {
  return axios({
    url: urlPrefix + '/layer/mark/mark/search',
    method: 'get',
    params: params
  })
}
/// ///////////////////////////////////////文件夹//////////////////////////////////////////
// 新建图层文件夹
export function addFolder (data) {
  return axios({
    url: urlPrefix + '/layer/folder',
    method: 'post',
    data: data
  })
}
// 更新图层文件夹
export function updateFolder (data) {
  return axios({
    url: urlPrefix + '/layer/folder',
    method: 'put',
    data: data
  })
}
// 删除图层文件夹
export function delFolder (data) {
  return axios({
    url: urlPrefix + '/layer/folder',
    method: 'delete',
    data: data
  })
}
// 获取单个图层文件夹详细信息
export function getFolder (params) {
  return axios({
    url: urlPrefix + '/layer/folder',
    method: 'get',
    params: params
  })
}
// 获取附带图层列表的文件夹列表(树状结果)
export function getLayerTree (params) {
  return axios({
    url: urlPrefix + '/layer/folder/list/layers',
    method: 'get',
    params: params
  })
}
// 文件夹列表
export function getFolderList (params) {
  return axios({
    url: urlPrefix + '/layer/folder/list',
    method: 'get',
    params: params
  })
}
// 文件夹列表(树形结构)
export function getFolderTree (params) {
  return axios({
    url: urlPrefix + '/layer/folder/list/tree',
    method: 'get',
    params: params
  })
}
/// ///////////////////////////////////////图标//////////////////////////////////////////
// 添加图标
export function addIcon (data) {
  return axios({
    url: urlPrefix + '/icon/list',
    method: 'post',
    data: data
  })
}
// 删除图标
export function delIcon (data) {
  return axios({
    url: urlPrefix + '/icon',
    method: 'delete',
    data: data
  })
}
// 获取图标列表
export function getIcons (params) {
  return axios({
    url: urlPrefix + '/icon/list',
    method: 'get',
    params: params
  })
}

/**
 * 导入kml 数据
 * @param {*} layerId 导入的图层id
 * @param {*} geoJson 要素数组
 * @returns
 */
export function kmlImport (layerId, geoJsons) {
  const data = geoJsons.map((geoJson) => ({
    name: geoJson.name,
    layerId,
    geoJson
  }))
  // console.log(data)
  return axios.post('/map/layer/mark/kmlImport', data)
}

// 获取空间查询列表数据
export function getSpaceSearchList (params) {
  return axios({
    url: urlPrefix + '/layer/mark/space/query',
    method: 'post',
    data: params
  })
}

// 获取空间查询统计数据
export function getSpaceSearchStatistics (params) {
  return axios({
    url: urlPrefix + '/layer/mark/space/statistics',
    method: 'post',
    data: params
  })
}
